import { ReactNode } from 'react';
import { OrderOptionsValues } from '@bandido/shared/enums';

export enum QueryKeys {
  commercialQuotes = 'commercialQuotes',
  DASHBOARD_CASES_BY_CHANNEL = 'dashboard-cases-by-channel',
  DASHBOARD_CASES_BY_DAY = 'dashboard-cases-by-day',
  DASHBOARD_CASES_BY_HOUR_AND_CHANNEL = 'dashboard-cases-by-hour-and-channel',
  DASHBOARD_CASES_NEED_AGENT_BY_TIME = 'dashboard-cases-need-agent-by-time',
  DASHBOARD_MISSING_AGENT = 'dashboard-missing-agent',
  DASHBOARD_TODAY_CASES = 'dashboard-today-cases',
  getContentExtractorJobs = 'getContentExtractorJobs',
  getTokenOrganizations = 'getTokenOrganizations',
  getAllAgencies = 'getAllAgencies',
  getMyAgencies = 'getMyAgencies',
  getAgencyById = 'getAgencyById',
  getAllCases = 'getAllCases',
  getInfinityCases = 'getInfinityCases',
  getAllClients = 'getAllClients',
  getClientByPhone = 'getClientByPhone',
  getAllHotelCategories = 'getAllHotelCategories', // TODO: DELETE
  getAllMappedHotelCategories = 'getAllMappedHotelCategories', // TODO: DELETE
  getAllHotelImageTags = 'getAllHotelImageTags', // TODO: DELETE
  getAllHotelSuppliers = 'getAllHotelSuppliers', // TODO: DELETE
  getAllHotelExtractorSuppliers = 'getAllHotelExtractorSuppliers', // TODO: DELETE
  getAllHotels = 'getAllHotels', // TODO: DELETE
  getHotelPropertyFares = 'getHotelPropertyFares',
  getAllTeams = 'getAllTeams',
  getTeamsByTokensAgencies = 'getTeamsByTokensAgencies',
  getAllUsers = 'getAllUsers',
  getAllWorkflows = 'getAllWorkflows',
  getAmenititesBySupplier = 'getAmenititesBySupplier',
  getAllAmenitites = 'getAllAmenitites',
  getAllMappedAmenitites = 'getAllMappedAmenitites',
  getCategoriesBySupplier = 'getCategoriesBySupplier',
  getCaseHandlers = 'getCaseHandlers',
  getCalls = 'getCalls',
  getCaseById = 'getCaseById',
  getCaseHistory = 'getCaseHistory',
  getCaseTravelers = 'getCaseTravelers',
  getCaseTravelerSuggestions = 'getCaseTravelerSuggestions',
  getTravelerDocumentMatches = 'getTravelerDocumentMatches',
  getEmailThread = 'getEmailThread',
  getCaseSaleOrders = 'getCaseSaleOrders',
  getClientById = 'getClientById',
  getDefaultProviders = 'getDefaultProviders',
  getHotelData = 'getHotelData', // TODO: DELETE
  getHotelCardData = 'getHotelCardData', // TODO: DELETE
  getHotelRating = 'getHotelRating', // TODO: DELETE
  getHotelDupesTentative = 'getHotelDupesTentative', // TODO: DELETE
  getHotelImageTagById = 'getHotelImageTagById', // TODO: DELETE
  getHotelModeratedBy = 'getHotelModeratedBy', // TODO: DELETE
  getAgencyIVR = 'getAgencyIVR',
  getMyUserData = 'getMyUserData',
  getMyUserAgencies = 'getMyUserAgencies',
  getRelatedCases = 'getRelatedCases',
  getSettingsByAgencyId = 'getSettingsByAgencyId',
  getStepsByManyWorkflowIds = 'getStepsByManyWorkflowIds',
  getTeamById = 'getTeamById',
  getUserAvailability = 'getUserAvailability',
  getUserById = 'getUserById',
  getUsersByAgency = 'getUsersByAgency',
  getUsersByTokensAgency = 'getUsersByTokensAgency',
  getUsersByTeam = 'getUsersByTeam',
  getUsersByOrganization = 'getUsersByOrganization',
  getWorkflowById = 'getWorkflowById',
  getWorkflowsForCase = 'getWorkflowsForCase',
  getWorkflowSteps = 'getWorkflowSteps',
  postBookFare = 'postBookFare',
  postConfirmFare = 'postConfirmFare',
  updateStep = 'updateStep',
  updateWorkflow = 'updateWorkflow',
  getStepConnections = 'getStepConnections',
  getFeatureFlags = 'getFeatureFlags',
  getSupportFormsByAgency = 'getSupportFormsByAgency',
  getSupportFormById = 'getSupportFormById',
  getWhatsappMessages = 'getWhatsappMessages',
  getWhatsappClientMessages = 'getWhatsappClientMessages',
  getOrganizationsByAgencyId = 'getOrganizationsByAgencyId',
  getOrganizationById = 'getOrganizationById',
  getNotifications = 'getNotifications',
  getCaseSavedFilters = 'getCaseSavedFilters',
  getUserAgencies = 'getUserAgencies',
  getHotelFares = 'getHotelFares',
  getFieldBlocks = 'getFieldBlocks',
  getFieldBlockById = 'getFieldBlockById',
  getFieldBlockByWorkflowId = 'getFieldBlockByWorkflowId',
  getFieldBlockByWorkflowIds = 'getFieldBlockByWorkflowIds',
  getCaseCustomFields = 'getCaseCustomFields',
  getMarkupRulesByAgencyId = 'getMarkupRulesByAgencyId',
  saleOrder = 'saleOrder',
  getHotelContentAutoComplete = 'getHotelContentAutoComplete',
  gupshupSubscriptions = 'gupshupSubscriptions',
  gupshupTemplates = 'gupshupTemplates',
  getWhatsappQuickReplies = 'getWhatsappQuickReplies',
  gupshupActiveConversations = 'gupshupActiveConversations',
  getSaleOrdersForDashboard = 'getSaleOrdersForDashboard',
  getSaleOrdersDetails = 'getSaleOrdersDetails',
  getSaleOrdersPaxes = 'getSaleOrdersPaxes',
  getSaleOrdersItems = 'getSaleOrdersItems',
  getInvalidationRuleById = 'getInvalidationRuleById',
  getCasesStatsByDay = 'getCasesStatsByDay',
  getCasesStatsByTeam = 'getCasesStatsByTeam',
  getCasesStatsByStatus = 'getCasesStatsByStatus',
  getCasesStatsByWorkflow = 'getCasesStatsByWorkflow',
  getCasesStatistics = 'getCasesStatistics',
  getNeedAgentStats = 'getNeedAgentStats',
  getCasesByPeriods = 'getCasesByPeriods',
  getCasesResolvedByPeriods = 'getCasesResolvedByPeriods',
  getCasesNeedAgentByTimeOpen = 'getCasesNeedAgentByTimeOpen',
  getCasesByDayOfWeek = 'getCasesByDayOfWeek',
  getCasesByDayAndHour = 'getCasesByDayAndHour',
  getImportantNumbers = 'getImportantNumbers',
  getAvailableCountries = 'getAvailableCountries',
  getAgents = 'getAgents',
  getAgentsStatusSummary = 'getAgentsStatusSummary',
  getPaginatedClientUploads = 'getPaginatedClientUploads',
  getPaginatedCaseUploads = 'getPaginatedCaseUploads',
  getModeratedHotelsAmenities = 'getModeratedHotelsAmenities',
  getModeratedHotelsMedias = 'getModeratedHotelsMedias',
  getModeratedHotelsCheckOptions = 'getModeratedHotelsCheckOptions',
  getModeratedHotelsDescriptions = 'getModeratedHotelsDescriptions',
  getAllHotelIntegrations = 'getAllHotelIntegrations',
  getAHotelIntegrationById = 'getAHotelIntegrationById',
  getUserNotificationTriggers = 'getUserNotificationTriggers',
  getUserNotificationTriggerCapabilities = 'getUserNotificationTriggerCapabilities',
  createUserNotificationTrigger = 'createUserNotificationTrigger',
  getIAConfigByAgencyId = 'getIAConfigByAgencyId',

  // CONTENT EXTRACTOR
  getHotelVendorHotels = 'getHotelVendorHotels',
  getHotelSuppliers = 'getHotelSuppliers',
  getHotelDestinations = 'getHotelDestinations',
  getHotelBoards = 'getHotelBoards',
  getHotelCategories = 'getHotelCategories',
  getHotelNimbuxHotels = 'getHotelNimbuxHotels',
  getHotelVendorHotelById = 'getHotelVendorHotelById',
  getHotelNimbuxHotelById = 'getHotelNimbuxHotelById',
  getNimbuxHotelImages = 'getNimbuxHotelImages',
  getModeratedVendorHotelsById = 'getModeratedVendorHotelsById',
  getHotelAmenities = 'getHotelAmenities',
  getVendorHotelDescriptions = 'getVendorHotelDescriptions',
  getCaseTriggers = 'getCaseTriggers',
  getWebhooks = 'getWebhooks',
  getMetaCapiConfig = 'getMetaCapiConfig',
  getCopilotConfigs = 'getCopilotConfigs',
  getAgencyKnowledge = 'getAgencyKnowledge',
  getAgencyKnowledgeTags = 'getAgencyKnowledgeTags',
  getRuteroConnectors = 'getRuteroConnectors',
  getTravelBookings = 'getTravelBookings',
  getPowerErpConnection = 'getPowerErpConnection',
  getPowerErpCaseSummary = 'getPowerErpCaseSummary',
  getPowerErpOrderOptions = 'getPowerErpOrderOptions',
  getPowerErpOrganizationDefaults = 'getPowerErpOrganizationDefaults',
  getPowerErpOrganizationBillable = 'getPowerErpOrganizationBillable',
  getPowerErpHotelConnections = 'getPowerErpHotelConnections',
  getPowerErpProviderSearch = 'getPowerErpProviderSearch',
  getPowerErpCaseBookings = 'getPowerErpCaseBookings',
  getPowerErpAddPreview = 'getPowerErpAddPreview',
  getPowerErpTravelersPreview = 'getPowerErpTravelersPreview',
  getPowerErpBillingCatalog = 'getPowerErpBillingCatalog',
  getPowerErpTravelerBilling = 'getPowerErpTravelerBilling',
  /** El voucher de agencia de UNA reserva: clave propia, fuera del prefijo de la lista. */
  getTravelBookingVoucher = 'getTravelBookingVoucher',
  getVoucherConfig = 'getVoucherConfig',
  getRuteroCatalog = 'getRuteroCatalog',
  getRuteroSearch = 'getRuteroSearch',
  getRuteroOfferOptionsPreview = 'getRuteroOfferOptionsPreview',
  getPlacesGeocodeAutocomplete = 'getPlacesGeocodeAutocomplete',
  getPlaceCoords = 'getPlaceCoords',
}

type roomInfo = {
  adults: number;
  kids?: number;
  babies?: number;
};

export type IHotelSearch = {
  destination: string;
  initialDate?: string;
  endDate?: string;
  rooms: roomInfo[];
};

export interface ControlledFieldProp {
  formFieldName: string;
  text: string;
  error?: string;
  icon?: ReactNode;
}

export interface SortingOptions {
  sort: string;
  order: OrderOptionsValues;
}

export interface OptionType {
  label: string;
  value: string;
}
